import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type {
    RetrievalElementsApi,
    GetRetrievalElementsResponse,
    GetRetrievalElementsAsyncResponse,
    UpdateRetrievalElementsRequest,
    UpdateRetrievalElementsResponse,
    ExtendRetrievalElementRequest,
    ExtendRetrievalElementResponse,
} from '../retrieval-elements-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

/**
 * 检索要素API实现
 */
@injectable()
export class RetrievalElementsApiImpl
    extends PsHttpService
    implements RetrievalElementsApi {

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    /**
     * 获取检索要素
     * @param taskId 任务ID
     * @param signal abort 信号
     * @returns 异步检索要素数据
     */
    async getRetrievalElements(taskId: string, signal?: AbortSignal): Promise<GetRetrievalElementsAsyncResponse> {
        const result = await this.get<PatSnapSuccessResponseData<GetRetrievalElementsAsyncResponse>>({
            url: `novelty-search/get-retrieval-elements/${taskId}`,
            signal,
        });
        return result.data;
    }

    /**
     * 更新检索要素
     * @param data 更新检索要素请求数据
     * @returns 更新结果
     */
    async updateRetrievalElements(data: UpdateRetrievalElementsRequest): Promise<UpdateRetrievalElementsResponse> {
        const result = await this.post<PatSnapSuccessResponseData<UpdateRetrievalElementsResponse>>({
            url: 'novelty-search/update-retrieval-elements',
            data,
        });
        return result.data;
    }

    /**
     * 扩展单个检索要素
     * @param data 扩展检索要素请求数据
     * @returns 扩展结果
     */
    async extendRetrievalElement(data: ExtendRetrievalElementRequest): Promise<ExtendRetrievalElementResponse> {
        const result = await this.post<PatSnapSuccessResponseData<ExtendRetrievalElementResponse>>({
            url: 'novelty-search/retrieval-element-extend',
            data,
            cache: true,
        });
        return result.data;
    }
}
